import { get } from 'lodash-es';

export const selectReturnByReturnDetailModalId = (state, props = {}) => get(state, `${props.returnDetailModalId}.returnShipment`);
export const selectReturnDetailsByReturnDetailModalId = (state, props = {}) => get(state, `${props.returnDetailModalId}`);
export const selectReturnDetailModalIdByFulfillmentId = (state, props = {}) => get(state, `returnIdToModalIdMap[${props.fulfillmentId}]`);
